import React from "react";
import "./App.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "bootstrap/dist/css/bootstrap.css";

import Table from "./components/table";
import {
  Container,
  Navbar,
  Nav,
  Jumbotron,
  Button,
  Row,
  Col
} from "react-bootstrap";

function App() {
  return (
    <div>
      <Container>
      <h4> Jobs Finder in India Join our <a href="https://t.me/csejobs20"> Telegram </a>Channel for regular updates</h4>
        <Table source="linkedin"></Table>
      </Container>
     </div>
  );
}

export default App;
